import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ChevronDown, Mail, Linkedin, Twitter } from 'lucide-react';
import { useSelector } from 'react-redux';
import { getFileUrl } from '../../utils/helper';
import { Link } from 'react-router-dom';
import { CONTACT_ROUTE } from '../../routes/web/rootRoutes';

function TeamAndFAQ() {
    const [openFAQ, setOpenFAQ] = useState(null);

    const faqs = useSelector((state) => state?.globalState?.siteSetting?.faqs);
    const teams = useSelector((state) => state?.globalState?.siteSetting?.teams);

    const departmentOrder = ['A', 'B', 'C', 'D', 'all'];

    console.log(teams);
    

    const toggleFAQ = (id) => {
        setOpenFAQ(openFAQ === id ? null : id);
    };




    return (
        <div className="bg-gray-50">
            {

                <section className="py-12 md:py-20">
                    <div className="px-4 mx-auto max-w-7xl">
                        <div className="mb-12 text-center md:mb-16" data-aos="fade-up">
                            <span
                                className="inline-block px-4 py-1.5 bg-gradient-to-r from-red-500 to-yellow-500 text-white text-sm font-semibold rounded-full mb-4">
                                Leadership
                            </span>
                            <h2 className="mb-4 text-3xl font-bold text-gray-900 md:text-5xl lg:text-6xl">
                                Meet Our Team
                            </h2>
                            <p className="max-w-2xl mx-auto text-base text-gray-600 md:text-lg">
                                Dedicated professionals leading ACTADCD Mumbai with passion and expertise
                            </p>
                        </div>

                         <div>
      {departmentOrder.map((key) => {
        const members = teams?.[key] || [];
        if (members.length === 0) return null;

        const isLessThanFour = members.length < 4;

        return (
          <div
            key={key}
            className={`${
              isLessThanFour
                ? "md:flex md:flex-wrap md:justify-center grid grid-cols-2   gap-3 md:gap-8 mb-10"
                : "grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-8 mb-10"
            }`}
          >
            {members.map((memberWrapper, index) => {
              // Handle both data formats:
              const member = memberWrapper.team ? memberWrapper.team : memberWrapper;

              return (
                <div
                  key={member.id}
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                  className="w-full overflow-hidden transition-all duration-500 bg-white shadow-sm group rounded-2xl hover:shadow-xl sm:w-auto lg:w-72"
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={getFileUrl(member?.image, "section")}
                      alt={member?.title || ""}
                      className="object-cover w-full h-40 transition-transform duration-500 md:h-64 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 transition-opacity duration-500 opacity-0 bg-gradient-to-t from-black/60 to-transparent group-hover:opacity-100" />
                  </div>

                  <div className="p-1 text-center md:p-6">
                    <h3 className="text-[14px] md:text-xl  font-bold text-gray-900 mb-1">
                      {member?.title}
                    </h3>
                    <p className="text-red-600 font-semibold text-[10px] md:text-sm mb-3">
                      {member?.link}
                    </p>
                    <p className="text-sm leading-relaxed text-gray-600">
                      {member?.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>



                    </div>
                </section>
            }

            <section className="py-12 bg-white md:py-20">
                <div className="max-w-4xl px-4 mx-auto">
                    <div className="mb-12 text-center md:mb-16" data-aos="fade-up">
                         <Link to={CONTACT_ROUTE}>
                        <span
                            className="inline-block px-4 py-1.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-semibold rounded-full mb-4">
                            Help Center
                        </span>
                        </Link>
                        <h2 className="mb-4 text-3xl font-bold text-gray-900 md:text-5xl lg:text-6xl">
                            Frequently Asked Questions
                        </h2>
                        <p className="max-w-2xl mx-auto text-base text-gray-600 md:text-lg">
                            Find answers to common questions about membership, services, and more
                        </p>
                    </div>

                    <div className="space-y-4" data-aos="fade-up" data-aos-delay="200">
                        {faqs.map((faq, index) => (
                            <div key={faq.id}
                                className="overflow-hidden transition-all duration-300 border-2 border-gray-100 bg-gray-50 rounded-xl hover:border-red-200">
                                <button onClick={() => toggleFAQ(faq.id)}
                                    className="flex items-center justify-between w-full px-6 py-5 text-left transition-colors hover:bg-gray-100"
                                >
                                    <span className="pr-4 text-sm font-semibold text-gray-900 md:text-base">
                                        {faq.question}
                                    </span>
                                    <ChevronDown className={`flex-shrink-0 text-red-500 transition-transform duration-300
                        ${openFAQ === faq.id ? 'rotate-180' : ''}`} size={20} />
                                </button>

                                <div className={`overflow-hidden transition-all duration-300 ${openFAQ === faq.id ? 'max-h-96 opacity-100'
                                    : 'max-h-0 opacity-0'}`}>
                                    <div className="px-6 pb-5 text-sm leading-relaxed text-gray-600 md:text-base">
                                        {faq.description}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="mt-12 text-center" data-aos="fade-up" data-aos-delay="300">
                        <p className="mb-6 text-gray-600">
                            Still have questions? We're here to help!
                        </p>
                        <Link to={CONTACT_ROUTE}
                            className="inline-flex items-center gap-2 px-8 py-3 font-semibold text-white transition-all duration-300 transform rounded-full shadow-lg bg-gradient-to-r from-red-500 to-yellow-500 hover:shadow-xl hover:scale-105">
                            Contact Us
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default TeamAndFAQ;
